import { Jaco } from "oc-jaco3d/arrangement/Jaco";
import { Box3, Vector3 } from "three";
import { v3 } from "oc-threejs/short3";
import { Leerrohr3d } from "../arrangement3d/Leerrohr3d";

export class Leerrohr extends Jaco {
  static CLASS_NAME = "Leerrohr";

  paths: Vector3[][] = [];

  update3d() {
    super.update3d();
  }

  getBox(): Box3 {
    return new Box3().setFromPoints(this.paths.flatMap((p) => p));
  }

  /**
   * gibt die Size im eigenen lokalen Koordinatensystem zurück
   * @returns {THREE.Vector3}
   */
  getSize(): Vector3 {
    return this.getBox().getSize(v3());
  }

  createJaco3d() {
    return new Leerrohr3d(this);
  }
}
